import { render, staticRenderFns } from "./RegistroBandas.vue?vue&type=template&id=70c8ed2e&scoped=true&"
import script from "./RegistroBandas.vue?vue&type=script&lang=js&"
export * from "./RegistroBandas.vue?vue&type=script&lang=js&"
import style0 from "./RegistroBandas.vue?vue&type=style&index=0&id=70c8ed2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c8ed2e",
  null
  
)

export default component.exports